import styled from 'styled-components';

const FaqContainer = styled.div`
  display: flex;
  flex-direction: column;

  h1 {
    margin: 0 auto 4.5rem auto;
  }
`;

export default FaqContainer;
